export default __webpack_public_path__ + "static/media/icon-Dale01.f97f16c4.svg";